import createVueComponent from '../createVueComponent';

const FlagTriangleRight = createVueComponent('FlagTriangleRightIcon', [
  ['path', { d: 'M7 22V2l10 5-10 5' }],
]);

export default FlagTriangleRight;
